<template>
    <div>
        <div class="flex justify-content-center text-center">
            <a style="cursor: pointer" v-if="addAllLabel" @click="addAll()">{{ addAllLabel }}</a>
            <input type="text" v-model="search" class="form-control">
        </div>
        <div style="position: relative; margin-top: 5px; border-radius: 5px; border:#00afee solid 1px">
            <ul  style=" height: 225px !important; margin-left: -40px; overflow-y: auto; list-style: none">
                <li style="cursor: pointer; padding-left: 15px; padding-top: 5px; padding-bottom: 5px; border-bottom: lightgray 1px solid; color: #555; font-size: 14px" v-for="item in filterList" @click="selectItem(item)">
                    {{item.codigo ? item.codigo + ' - ' : ''}}{{item.descricao}}
                </li>
            </ul>
        </div>
    </div>

</template>

<script>

export default {
        name: 'c-atlas-select-box',
        props: [
            'items',
            'removeSelected',
            'addAllLabel'
        ],
        data() {
            return {
                search: '',
                data: this.items,
                selected: [],
            };
        },

        computed: {
            filterList() {
                if (!this.search) {
                    return this.data;
                }
                return this.data.filter((item) => {
                    const fullDescription = item.hasOwnProperty('codigo')
                        ? item.codigo + ' - ' +  item.descricao : item.descricao;

                    return fullDescription.toLowerCase().includes(this.search.toLowerCase());
                });
            }
        },

        methods: {
            selectItem(item) {
                this.selected.push(item);
                const selecteds = this.selected.map((item) => item.id)
                if (this.removeSelected === true) {
                    this.data = this.data.filter((item) => !selecteds.includes(item.id))
                }
                this.$emit('selectItem', item, this.data);
            },

            addAll() {
                this.data.forEach((item) => this.selectItem(item));
            }
        }
    };
</script>
